import React from 'react'
export class ComponentToPrint extends React.PureComponent {
  render () {
    return this.props.component
  }
}
